import { useLocation } from "react-router";

export function useFullDashboardPath() {
  const { pathname } = useLocation();
  // Remove /dashboard prefix and return the rest
  const pathWithoutDashboard = pathname.replace(/^\/dashboard\/?/, "");
  return pathWithoutDashboard || "";
}